<template>
    <TableCell @mouseover="hovered = true" @mouseleave="hovered = false">
        <div class="gap-2 flex items-start">
            <kbd v-if="showValueAsKbd" class="break-all" @click="copy(value)">{{
                value
            }}</kbd>
            <p v-else class="break-all" @click="copy(value)">{{ value }}</p>

            <Copy
                v-if="hovered && !copied"
                :size="16"
                class="shrink-0"
                @click="copy(value)"
            />
            <ClipboardCheck
                v-else-if="copied"
                :size="16"
                class="shrink-0"
                @click="copy(value)"
            />
            <div v-else class="h-4 w-4 shrink-0"></div>
        </div>
    </TableCell>
</template>

<script setup lang="ts">
import { useClipboard } from "@vueuse/core";
import { TableCell } from "@/components/ui/table";
import { Copy, ClipboardCheck } from "lucide-vue-next";
import { ref } from "vue";
const { copy, copied } = useClipboard();

const hovered = ref(false);
defineProps<{
    value: string;
    showValueAsKbd?: boolean;
}>();
</script>
